import { ImageResizeMode, ImageStyle, StyleProp } from "react-native";
import { atom } from "recoil";

type ImageProps = {
    testID?: string;
    style: StyleProp<ImageStyle>[];
    resizeMode: ImageResizeMode;
};

type Image = {
    avatarPath: string | number;
    props: ImageProps;
};

type Position = {
    pageX: number;
    pageY: number;
    size: number;
};

export type EnlargeAvatarData = {
    image: Image;
    initialPosition: Position;
};

export const enlargeAvatarData = atom<EnlargeAvatarData | null>({
    key: "enlargeAvatarData",
    default: null,
});
